<div class="area-create">

    <div class="area-create__panel" [ngClass]="{'area-create__panel--visible': step === Step.TypeSelection}">
        <div class="area-create__type" (click)="selectAreaType(AreaTypeEnum.Circle)" title="{{'map.select-circle' | translate}}">
            <div class="area-create__type-icon area-create__type-icon--circle"></div>
        </div>
        <div class="area-create__type" (click)="selectAreaType(AreaTypeEnum.Polygon)" title="{{'map.select-polygon' | translate}}">
            <div class="area-create__type-icon area-create__type-icon--polygon"></div>
        </div>
        <div class="area-create__type" (click)="selectAreaType(AreaTypeEnum.Line)" title="{{'map.select-line' | translate}}">
            <div class="area-create__type-icon area-create__type-icon--line"></div>
        </div>
    </div>

    <div class="area-create__header">

        <div *ngIf="step === Step.Default" class="area-create__mode" (click)="addArea()">
            <span class="area-create__plus-icon">+</span>
            <span class="area-create__label">{{'map.new-area' | translate}}</span>
        </div>

        <div *ngIf="step !== Step.Default" class="area-create__mode" title="{{'map.cancel-area-selection' | translate}}">
            <span class="area-create__cancel-icon" (click)="cancel()"></span>
        </div>

    </div>

</div>
